import { isNextStyleEnabled } from "@1js/acui-theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";
import {
  getRibbonBottomBarStylingConstants,
  getLabelContainerHeight,
  vNextTopBottomMargin,
} from "../../ribbonStylingConstants";

export interface RibbonControlGroupClassNames {
  root: string;
  container: string;
  groupLabel: string;
  groupLabelContainer: string;
  layoutWrapper: string;
}

export const layoutWrapperTransitionClassNames = {
  enter: "controlGroupLayout-enter",
  enterActive: "controlGroupLayout-enter-active",
  exit: "controlGroupLayout-exit",
  exitActive: "controlGroupLayout-exit-active",
};

const layoutScaleTransitionDuration = 300;
const layoutOpactiyTransitionDuration = 87;
export const layoutTransitionExitDuration = layoutOpactiyTransitionDuration;
export const layoutTransitionEnterDuration =
  layoutOpactiyTransitionDuration + layoutScaleTransitionDuration;

export const getRibbonControlGroupMLRClassNames = memoizeFunction(
  (
    enterInitialWidth: number | undefined,
    finalWidth: number | undefined,
    allowPointerEvents?: boolean,
    shouldDisableGroupLabel?: boolean
  ): RibbonControlGroupClassNames => {
    return mergeStyleSets(
      {
        root: {
          display: "inline-block",
          verticalAlign: "top",
          pointerEvents: allowPointerEvents && "auto",
          selectors: {
            [`.controlGroupLayout-enter & .layoutWrapper .moved`]: {
              opacity: 0,
            },
            [`.controlGroupLayout-enter:not(.controlGroupLayout-enter-active) & .layoutWrapper`]:
              {
                width:
                  enterInitialWidth != null
                    ? `${enterInitialWidth}px !important`
                    : undefined,
              },
            [`.controlGroupLayout-enter-active & .layoutWrapper`]: {
              transition: `width ${layoutScaleTransitionDuration}ms  cubic-bezier(0.1, 0.9, 0.2, 1)`,
              width: finalWidth != null ? `${finalWidth}px` : undefined,
              opacity: 1,
            },
            [`.controlGroupLayout-enter-active & .layoutWrapper .moved`]: {
              transition: `opacity ${layoutOpactiyTransitionDuration}ms linear ${layoutScaleTransitionDuration}ms`,
              opacity: 1,
            },
            [`.controlGroupLayout-exit & .layoutWrapper .moved`]: {
              opacity: 1,
            },
            [`.controlGroupLayout-exit-active & .layoutWrapper .moved`]: {
              transition: `opacity ${layoutOpactiyTransitionDuration}ms linear`,
              opacity: 0,
            },
          },
        },
        container: {
          display: "flex",
          height:
            getRibbonBottomBarStylingConstants("Multiline").bottomBarHeight,
          flexDirection: "column",
        },
        groupLabel: {
          flexGrow: 1,
          textAlign: "center",
          userSelect: "none",
          fontSize: 10,
          lineHeight: 10,
          opacity: shouldDisableGroupLabel ? 0.4 : 1,
        },
        groupLabelContainer: {
          display: "flex",
          height: getLabelContainerHeight(),
          justifyContent: "flex-end",
        },
        layoutWrapper: {
          flex: 1,
          display: "inline",
        },
      },
      isNextStyleEnabled() && getRibbonControlGroupMLRClassNamesNext()
    );
  }
);

export const getRibbonControlGroupMLRClassNamesNext = memoizeFunction(
  (): RibbonControlGroupClassNames => {
    return mergeStyleSets({
      root: {},
      container: {
        height:
          getRibbonBottomBarStylingConstants("Multiline").bottomBarHeight -
          vNextTopBottomMargin * 2,
      },
      groupLabel: {},
      groupLabelContainer: {
        paddingTop: 2,
      },
      layoutWrapper: {},
    });
  }
);
